module.exports = __webpack_public_path__ + "assets/0de8db0a0f9a339913f6e865b4b8162e.mp3";